import { render, staticRenderFns } from "./antiMoneyLaunderingQuery.vue?vue&type=template&id=f1357858&scoped=true"
import script from "./antiMoneyLaunderingQuery.vue?vue&type=script&lang=js"
export * from "./antiMoneyLaunderingQuery.vue?vue&type=script&lang=js"
import style0 from "./antiMoneyLaunderingQuery.vue?vue&type=style&index=0&id=f1357858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1357858",
  null
  
)

export default component.exports